import analytics, {
  EventTypeElementImpression,
  EventTypeElementInteracted,
} from '@nerdwallet/analytics';

export const trackImpression = (entityName: string): void => {
  analytics.track<EventTypeElementImpression>('element_impression', {
    element_name: entityName,
    entity_name: entityName,
  });
};

export const trackInteraction = (
  elementName: string,
  impressionId: string,
  action: EventTypeElementInteracted['Payload']['action'] = 'close'
): void => {
  analytics.track<EventTypeElementInteracted>('element_interacted', {
    element_name: elementName,
    action,
    interaction_id: impressionId,
    interaction_type: 'press',
  });
};
